import React from 'react'
import { defaultLangKey } from '../../../locales'

const LangKeyContext = React.createContext(defaultLangKey)

export default LangKeyContext
